import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSubscription } from "@/provider/SubscriptionProvider";
import { useAuth } from "@/contexts/AuthContext";
import { PaywallModal } from "./PaywallModal";
import type { AuthStaffDO } from "@/types/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  canAccess?: (user: AuthStaffDO | null) => boolean;
  unauthorizedRedirectTo?: string;
}

export function ProtectedRoute({
  children,
  canAccess,
  unauthorizedRedirectTo = "/dashboard",
}: ProtectedRouteProps) {
  const { isAuthenticated, isAuthReady, user, isAdminView } = useAuth();
  const { isSubscriptionActive, isLoading } = useSubscription();
  const [devUnlocked, setDevUnlocked] = useState(false);

  if (!isAuthReady) {
    return null; // Or a <LoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (canAccess && !canAccess(user)) {
    return <Navigate to={unauthorizedRedirectTo} replace />;
  }

  // const showPaywall = !isSubscriptionActive && !devUnlocked;
  const showPaywall = !isAdminView && !isLoading && !isSubscriptionActive;

  return (
    <>
      {children}
      <PaywallModal
        isOpen={showPaywall}
        onDevUnlock={() => setDevUnlocked(true)}
      />
    </>
  );
}
